<template>
  <div>
    <v-container fluid>
      <!-- Search Date and Provider -->
      <v-card class="card2">
        <div class="pa-4" style="margin-top: -12px">
          <div class="d-flex align-center" style="gap: 12px">
            <h1 style="color: #171717; font-weight: 600; font-size: 20px">Welcome, {{ username }}</h1>
            <img src="@/assets/smile-icon.svg" alt="img" width="24" height="24" />
          </div>

          <div class="d-flex align-center justify-space-between" style="margin-top: -16px">
            <p style="color: #646464; font-size: 14px">{{ $t('_fullOverview') }}</p>
            <div class="monthly-design" style="gap: 16px">
              <p style="color: #646464; font-weight: 600; font-size: 14px">{{ $t('monthly') }}</p>
              <v-autocomplete v-model="selectedMonth" :items="monthList" item-title="text" item-value="value" :placeholder="$t('monthly')" variant="plain" density="compact" class="monthly-input mt-6">
                <template #prepend-inner>
                  <img src="@/assets/Calendar Gray.svg" alt="img" width="20" height="20" style="margin-top: -2px; margin-left: 8px" />
                </template>
              </v-autocomplete>
            </div>
          </div>
        </div>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="mb-1 d-flex align-center" style="gap: 2px">
                    <label for="Provider" class="text-sm font-medium text-gray-700">
                      {{ $t('provider') }}
                    </label>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="Prompt token cost info" width="18" height="18" style="cursor: pointer; margin-left: 4px" />
                      </template>
                      <span>{{ $t('_selectProviderTooltip') }}</span>
                    </v-tooltip>
                  </div>
                  <v-autocomplete
                    id="provider-autocomplete-dashboard"
                    :placeholder="$t('provider')"
                    :items="listDDProvider"
                    item-title="providerName"
                    item-value="providerName"
                    v-model="provider"
                    variant="plain"
                    density="compact"
                    color="primary"
                    class="modern-input"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'provider-option-' + index" :value="item.raw.providerName">
                        <template v-slot:title>
                          <span>{{ item.raw.providerName }}</span>
                        </template>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="4">
              <v-row>
                <v-col cols="12" sm="12" md="11">
                  <div class="mb-1 d-flex align-center" style="gap: 2px">
                    <label for="Start Date" class="text-sm font-medium text-gray-700">
                      {{ $t('startDate') }}
                    </label>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="Completion token cost info" width="18" height="18" style="cursor: pointer; margin-left: 4px" />
                      </template>
                      <span>{{ $t('selectStartDateSearch') }}</span>
                    </v-tooltip>
                  </div>
                  <v-menu v-model="startDateFlag" :close-on-content-click="false" location="bottom" min-width="auto">
                    <template v-slot:activator="{ props }">
                      <v-text-field
                        id="startdate-field-dashboard"
                        :model-value="formatDateDisplay(startDate)"
                        :placeholder="$t('startDate')"
                        readonly
                        variant="none"
                        color="grey"
                        density="compact"
                        v-bind="props"
                        class="date-style"
                      >
                        <template #prepend-inner>
                          <img src="@/assets/lets-icons_date-range-duotone.svg" alt="img" width="20" height="20" style="margin-left: 6px" />
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="startDate"
                      color="red"
                      @update:model-value="
                        (val) => {
                          startDate = formatDate(val);
                          startDateFlag = false;
                        }
                      "
                      :max="endDate != null ? endDate : null"
                    />
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="12" md="1" class="dashboard-date-divider-col">
                  <div class="date-divider">-</div>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="4">
              <v-row>
                <v-col cols="12" sm="12" md="10">
                  <div class="mb-1 d-flex align-center" style="gap: 2px">
                    <label for="End Date" class="text-sm font-medium text-gray-700">
                      {{ $t('endDate') }}
                    </label>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18" style="cursor: pointer; margin-left: 4px" />
                      </template>
                      <span>{{ $t('selectEndDateSearch') }}</span>
                    </v-tooltip>
                  </div>
                  <v-menu v-model="endDateFlag" :close-on-content-click="false" location="bottom" min-width="auto">
                    <template v-slot:activator="{ props }">
                      <v-text-field
                        id="enddate-field-dashboard"
                        :model-value="formatDateDisplay(endDate)"
                        :placeholder="$t('endDate')"
                        readonly
                        variant="plain"
                        density="compact"
                        v-bind="props"
                        color="red"
                        class="date-style"
                      >
                        <template #prepend-inner>
                          <img src="@/assets/lets-icons_date-range-duotone.svg" alt="img" width="20" height="20" style="margin-left: 6px" />
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="endDate"
                      color="red"
                      :min="startDate != null ? startDate : null"
                      @update:model-value="
                        (val) => {
                          endDate = formatDate(val);
                          endDateFlag = false;
                        }
                      "
                    />
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="12" md="2" class="dashboard-search-col">
                  <div class="mt-8">
                    <button type="button" @click="Search" class="search-btn">
                      <img src="@/assets/search.svg" alt="img" width="18" height="18" style="margin-top: 6px" />
                    </button>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-row class="pa-4" style="margin-top: -36px">
          <v-col cols="12" sm="12" md="6">
            <v-skeleton-loader :loading="loadingCard" type="card">
              <v-card class="card-1">
                <div class="card-design">
                  <div class="mb-1 d-flex align-center" style="gap: 4px">
                    <label for="totalUser" style="color: #171717; font-weight: 400; font-size: 18px">
                      {{ $t('totalUser') }}
                    </label>
                    <v-tooltip location="top" max-width="360px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18" style="cursor: pointer; margin-left: 4px" />
                      </template>
                      <span>{{ $t('_totalUsersTooltip') }}</span>
                    </v-tooltip>
                  </div>
                  <span style="color: #171717; font-size: 40px; font-weight: 600"> {{ totalusage }} </span>
                  <div class="lastday-deseign">
                    <span style="color: #c32e0e; font-size: 16px; font-weight: 500"> {{ $t('LastDays') }} {{ daysDifference }} {{ $t('Days') }}</span>
                  </div>
                </div>
              </v-card>
            </v-skeleton-loader>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-skeleton-loader :loading="loadingCard" type="card">
              <v-card class="total-model-card">
                <div class="card-design">
                  <div class="mb-1 d-flex align-center" style="gap: 4px">
                    <label for="totalUser" style="color: #171717; font-weight: 400; font-size: 18px">
                      {{ $t('TotalModels') }}
                    </label>
                    <v-tooltip location="top" max-width="358px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18" style="cursor: pointer; margin-left: 4px" />
                      </template>
                      <span>{{ $t('_totalModelsTooltip') }}</span>
                    </v-tooltip>
                  </div>
                  <span style="color: #171717; font-size: 40px; font-weight: 600"> {{ totalusagegptflow }} </span>
                  <div class="lastday-deseign">
                    <span style="color: #c32e0e; font-size: 16px; font-weight: 500"> {{ $t('LastDays') }} {{ daysDifference }} {{ $t('Days') }}</span>
                  </div>
                </div>
              </v-card>
            </v-skeleton-loader>
          </v-col>

          <v-tooltip location="top" max-width="400px">
            <template v-slot:activator="{ props }">
              <div class="show-price-group" v-bind="props">
                <span style="font-size: 14px; color: #c32e0e; font-weight: 600">1 USD = 35 THB</span>
                <div class="action-divider"></div>
                <span style="font-size: 14px; color: #171717; font-weight: 600">{{ $t('showPrice') }}</span>
                <v-switch id="showprice-switch-dashboard" class="memory-switch" hide-details v-model="showPrice"></v-switch>
              </div>
            </template>
            <span>{{ $t('_showPriceTooltip') }}</span>
          </v-tooltip>
        </v-row>

        <v-row class="pa-4" style="margin-top: -32px">
          <v-col cols="12" sm="12" md="12">
            <div class="d-flex justify-start align-center" style="gap: 12px">
              <img src="@/assets/fluent_data-usage-sparkle-20-filled.svg" alt="img" width="20" height="20" />
              <span style="font-size: 18px; color: #171717; font-weight: 700">{{ $t('Usage') }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="12" md="3">
            <v-skeleton-loader :loading="loadingCard" type="card">
              <v-card class="card-3">
                <div class="card-design" style="padding: 10px">
                  <div class="d-flex align-center">
                    <span style="color: #ffffff; font-size: 14px"> {{ !showPrice ? $t('TotalTokenIn') : $t('TotalPriceForTokenIn') }} </span>
                    <v-tooltip location="top" max-width="310px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/Tooltip.svg" alt="info" width="18" height="18" />
                      </template>
                      <span>{{ !showPrice ? $t('_dashTotalTokenInTooltip') : $t('_dashTotalTokenInPriceTooltip') }}</span>
                    </v-tooltip>
                  </div>

                  <span style="color: #ffffff; font-size: 20px; font-weight: 600; margin-top: 6px"
                    >{{ !showPrice ? totalusagetoken : formatNumberWithComma(Number.parseFloat(TotalUsedprice)) }} {{ !showPrice ? '' : $t('baht') }}</span
                  >
                  <span style="color: #ffffff">{{ $t('LastDays') }} {{ daysDifference }} {{ $t('Days') }}</span>
                </div>
              </v-card>
            </v-skeleton-loader>
          </v-col>

          <v-col cols="12" sm="12" md="3">
            <v-skeleton-loader :loading="loadingCard" type="card">
              <v-card class="card-4">
                <div class="card-design" style="padding: 10px">
                  <div class="d-flex align-center">
                    <span style="color: #ffffff; font-size: 14px"> {{ !showPrice ? $t('TotalTokenOut') : $t('TotalPriceForTokenOut') }} </span>
                    <v-tooltip location="top" max-width="310px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/Tooltip.svg" alt="info" width="18" height="18" style="cursor: pointer; margin-left: 4px" />
                      </template>
                      <span>{{ !showPrice ? $t('_dashTotalTokenOutTooltip') : $t('_dashTotalTokenOutPriceTooltip') }}</span>
                    </v-tooltip>
                  </div>
                  <span style="color: #ffffff; font-size: 20px; font-weight: 600; margin-top: 6px"
                    >{{ !showPrice ? totalusagetokenschat : formatNumberWithComma(Number.parseFloat(TotalUsageChatPrice)) }} {{ !showPrice ? '' : $t('baht') }}</span
                  >
                  <span style="color: #ffffff">{{ $t('LastDays') }} {{ daysDifference }} {{ $t('Days') }}</span>
                </div>
              </v-card>
            </v-skeleton-loader>
          </v-col>

          <v-col cols="12" sm="12" md="3">
            <v-skeleton-loader :loading="loadingCard" type="card">
              <v-card class="card-5">
                <div class="card-design" style="padding: 10px">
                  <div class="d-flex align-center">
                    <span style="color: #ffffff; font-size: 14px"> {{ !showPrice ? $t('TokensUsedEmbedding') : $t('totalPriceForEmbedding') }} </span>
                    <v-tooltip location="top" max-width="290px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/Tooltip.svg" alt="info" width="18" height="18" style="cursor: pointer; margin-left: 4px" />
                      </template>
                      <span>{{ !showPrice ? $t('_dashEmbeddingTooltip') : $t('_dashEmbeddingPriceTooltip') }}</span>
                    </v-tooltip>
                  </div>
                  <span style="color: #ffffff; font-size: 20px; font-weight: 600; margin-top: 6px"
                    >{{ !showPrice ? totalusagetokensembedding : formatNumberWithComma(Number.parseFloat(TotalEmbeddingPrice)) }} {{ !showPrice ? '' : $t('baht') }}</span
                  >
                  <span style="color: #ffffff">{{ $t('LastDays') }} {{ daysDifference }} {{ $t('Days') }}</span>
                </div>
              </v-card>
            </v-skeleton-loader>
          </v-col>

          <v-col cols="12" sm="12" md="3">
            <v-skeleton-loader :loading="loadingCard" type="card">
              <v-card class="card-6">
                <div class="card-design" style="padding: 10px">
                  <div class="d-flex align-center">
                    <span style="color: #ffffff; font-size: 13px"> {{ !showPrice ? $t('TotalGeneratedImage') : $t('TotalGeneratedImagePrice') }} </span>
                    <v-tooltip location="top" max-width="280px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/Tooltip.svg" alt="info" width="18" height="18" style="cursor: pointer; margin-left: 4px" />
                      </template>
                      <span>{{ !showPrice ? $t('_dashImageTooltip') : $t('_dashImagePriceTooltip') }}</span>
                    </v-tooltip>
                  </div>
                  <span style="color: #ffffff; font-size: 20px; font-weight: 600; margin-top: 6px"
                    >{{ !showPrice ? totalAllImgGenerated : formatNumberWithComma((Number.parseFloat(totalAllImgPrice) * 35).toFixed(2)) }} {{ !showPrice ? '' : $t('baht') }}</span
                  >
                  <span style="color: #ffffff">{{ $t('LastDays') }} {{ daysDifference }} {{ $t('Days') }}</span>
                </div>
              </v-card>
            </v-skeleton-loader>
          </v-col>
        </v-row>

        <!-- Statistics Chart -->
        <v-row class="pa-4" style="margin-top: -32px">
          <v-col cols="12" sm="12" md="12">
            <div class="d-flex justify-start align-center" style="gap: 12px">
              <img src="@/assets/bar-chart-2-fill.svg" alt="img" width="20" height="20" />
              <span style="font-size: 18px; color: #171717; font-weight: 700">{{ $t('statistics') }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="12" md="4">
            <v-card class="doughnut-chart-card">
              <div class="d-flex justify-space-between align-center">
                <div class="mb-1 d-flex align-center" style="gap: 2px">
                  <label for="Provider" class="text-sm text-gray-700" style="font-weight: 600; font-size: 18px">
                    {{ $t('modelUsage') }}
                  </label>
                  <v-tooltip location="top" max-width="320px">
                    <template v-slot:activator="{ props }">
                      <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18" style="cursor: pointer; margin-left: 4px" />
                    </template>
                    <span>{{ $t('_tokenDistributionTooltip') }}</span>
                  </v-tooltip>
                </div>
                <div>
                  <span style="color: #c32e0e">{{ $t('_totalModels', { count: totalusagegptflow }) }}</span>
                </div>
              </div>

              <highcharts :options="chartPie"></highcharts>
              <!-- Model Colors Legend -->
              <div class="models-legend" style="padding: 16px">
                <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px">
                  <div v-for="model in chartPie.series[0].data" :key="model.name" class="legend-item" style="display: flex; align-items: center; gap: 8px">
                    <div
                      :style="{
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        backgroundColor: model.color,
                        flexShrink: 0,
                      }"
                    ></div>
                    <span style="font-size: 13px; color: #171717; font-weight: 500">
                      {{ model.name }}
                    </span>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12" md="8">
            <v-skeleton-loader :loading="loadingCard" type="card">
              <v-card class="line-chart-card">
                <div class="d-flex align-center" style="gap: 2px">
                  <label for="Provider" class="text-sm text-gray-700" style="font-weight: 600; font-size: 18px; padding: 0px 12px">
                    {{ $t('userUsage') }}
                  </label>
                  <v-tooltip location="top" max-width="320px">
                    <template v-slot:activator="{ props }">
                      <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18" style="cursor: pointer; margin-left: 4px" />
                    </template>
                    <span>{{ $t('_userUsageTooltip') }}</span>
                  </v-tooltip>
                </div>
                <highcharts v-if="isChartOptions" :options="chartOptions" style="padding: 8px"></highcharts>
              </v-card>
            </v-skeleton-loader>
          </v-col>
        </v-row>

        <!-- Token Usage By Model -->
        <v-row style="padding-left: 16px; padding-right: 16px">
          <v-col cols="12" sm="12" md="12">
            <div class="d-flex justify-start align-center" style="gap: 12px">
              <img src="@/assets/game-icons_token.svg" alt="img" width="20" height="20" />
              <span style="font-size: 18px; color: #171717; font-weight: 700">{{ $t('_tokenUsageByModel') }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="12" md="3">
            <v-skeleton-loader :loading="loadingCard" type="card">
              <v-card class="token-model-card-1">
                <div class="card-design" style="padding: 10px">
                  <div class="title-icon">
                    <span style="color: #f67760; font-size: 13px"> {{ !showPrice ? $t('ChatPromptTokens') : $t('totalPriceOfPromptChat') }} </span>
                    <v-tooltip location="top" max-width="280px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18" />
                      </template>
                      <span>{{ !showPrice ? $t('_dashChatPromptTooltip') : $t('_dashChatPromptPriceTooltip') }}</span>
                    </v-tooltip>
                  </div>
                  <span style="color: #c32e0e; font-size: 20px; font-weight: 600"
                    >{{ !showPrice ? totalusageprompttokenschat : formatNumberWithComma(Number.parseFloat(PromptPriceResult)) }} {{ !showPrice ? '' : $t('baht') }}</span
                  >
                  <span style="color: #646464">{{ $t('LastDays') }} {{ daysDifference }} {{ $t('Days') }}</span>
                </div>
              </v-card>
            </v-skeleton-loader>
          </v-col>

          <v-col cols="12" sm="12" md="3">
            <v-skeleton-loader :loading="loadingCard" type="card">
              <v-card class="token-model-card-2">
                <div class="card-design" style="padding: 10px">
                  <div class="title-icon">
                    <span style="color: #15c2b2; font-size: 13px"> {{ !showPrice ? $t('ChatCompletionTokens') : $t('totalPriceOfCompletionChat') }} </span>
                    <v-tooltip location="top" max-width="280px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18" />
                      </template>
                      <span>{{ !showPrice ? $t('_dashChatCompletionTooltip') : $t('_dashChatCompletionPriceTooltip') }}</span>
                    </v-tooltip>
                  </div>
                  <span style="color: #079770; font-size: 20px; font-weight: 600"
                    >{{ !showPrice ? totalusagecompletiontokenschat : formatNumberWithComma(Number.parseFloat(CompletionResult)) }} {{ !showPrice ? '' : $t('baht') }}</span
                  >
                  <span style="color: #646464">{{ $t('LastDays') }} {{ daysDifference }} {{ $t('Days') }}</span>
                </div>
              </v-card>
            </v-skeleton-loader>
          </v-col>
        </v-row>

        <v-row style="padding-left: 16px; padding-right: 16px">
          <v-col v-for="item in listDetailTokenUsed" :key="item.key" cols="12" v-if="listDetailTokenUsed != null">
            <v-skeleton-loader :loading="loadingCard" type="card">
              <v-row>
                <v-col cols="3" sm="3" md="3">
                  <v-card v-if="showCardgemini = true" class="token-model-card-3">
                    <div class="card-design" style="padding: 10px">
                      <div class="title-icon">
                        <span style="color: #fb86b0; font-size: 13px">
                          {{ !showPrice ? $t('GPT4oPromptTokens') : $t('totalPriceOfPromptChat') }}
                          ({{ item.modelName }})
                        </span>

                        <v-tooltip location="top" max-width="280px">
                          <template #activator="{ props }">
                            <img v-bind="props" src="@/assets/intent group toolip.svg" width="18" alt="" />
                          </template>
                          <span>{{ !showPrice ? $t('_dashModelPromptTooltip', { model: item.modelName }) : $t('_dashModelPromptPriceTooltip', { model: item.modelName }) }}</span>
                        </v-tooltip>
                      </div>

                      <span style="color: #ff4d4e; font-size: 20px; font-weight: 600">
                        {{ !showPrice ? item.totalPrompt_tokens : formatNumberWithComma(Number.parseFloat(item.totalPrompt_Price)) }}
                        {{ showPrice ? $t('baht') : '' }}
                      </span>

                      <span style="color: #646464"> {{ $t('LastDays') }} {{ daysDifference }} {{ $t('Days') }} </span>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="3" sm="3" md="3">
                  <v-card class="token-model-card-4">
                    <div class="card-design" style="padding: 10px">
                      <div class="title-icon">
                        <span style="color: #5db4e8; font-size: 13px">
                          {{ !showPrice ? $t('GPT4oUsageTokens') : $t('totalPriceOfCompletionChat') }}
                          ({{ item.modelName }})
                        </span>

                        <v-tooltip location="top" max-width="280px">
                          <template #activator="{ props }">
                            <img v-bind="props" src="@/assets/intent group toolip.svg" width="18" alt="" />
                          </template>
                          <span>{{ !showPrice ? $t('_dashModelCompletionTooltip', { model: item.modelName }) : $t('_dashModelCompletionPriceTooltip', { model: item.modelName }) }}</span>
                        </v-tooltip>
                      </div>

                      <span style="color: #217af0; font-size: 20px; font-weight: 600">
                        {{ !showPrice ? item.totalCompletion_tokens : formatNumberWithComma(Number.parseFloat(item.totalCompletion_Price)) }}
                        {{ showPrice ? $t('baht') : '' }}
                      </span>

                      <span style="color: #646464"> {{ $t('LastDays') }} {{ daysDifference }} {{ $t('Days') }} </span>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-skeleton-loader>
          </v-col>
        </v-row>

        <!-- Image Generation Usage In Chat -->
        <v-row class="pa-4">
          <v-col cols="12" sm="12" md="12">
            <div class="d-flex justify-start align-center" style="gap: 12px">
              <img src="@/assets/image-2-fill.svg" alt="img" width="20" height="20" />
              <span style="font-size: 18px; color: #171717; font-weight: 700">{{ $t('_imageGenerationUsageInChat') }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="12" md="3">
            <v-skeleton-loader :loading="loadingCard" type="card">
              <v-card class="image-gerneration-card-1">
                <div style="padding: 10px">
                  <div class="title-icon">
                    <span style="color: #b47ffe; font-size: 13px"> {{ !showPrice ? $t('ImageGenTotalInChat') : $t('ImageGenTotalPriceInChat') }} </span>
                    <v-tooltip location="top" max-width="280px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18" />
                      </template>
                      <span>{{ !showPrice ? $t('_dashChatImageTooltip') : $t('_dashChatImagePriceTooltip') }}</span>
                    </v-tooltip>
                  </div>
                  <div>
                    <span style="color: #8338ec; font-size: 20px; font-weight: 600"
                      >{{ !showPrice ? totalImgGenerated : formatNumberWithComma((Number.parseFloat(totalImgPrice) * 35).toFixed(2)) }} {{ !showPrice ? '' : $t('baht') }}</span
                    >
                  </div>
                  <div>
                    <span style="color: #646464">{{ $t('LastDays') }} {{ daysDifference }} {{ $t('Days') }}</span>
                  </div>
                </div>
              </v-card>
            </v-skeleton-loader>
          </v-col>

          <v-col v-for="item in listImgModelGen" :key="item.key" cols="12" sm="12" md="3" v-if="listImgModelGen != null">
            <v-skeleton-loader :loading="loadingCard" type="card">
              <v-card v-if="showCardgemini = true" class="image-gerneration-card-2">
                <div style="padding: 10px">
                  <div class="title-icon">
                    <span style="color: #a6d95e; font-size: 13px"> {{ !showPrice ? $t('ImageGenTotalInChat') : $t('ImageGenTotalPriceInChat') }} ({{ item.modelName }}) </span>
                    <v-tooltip location="top" max-width="280px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18" />
                      </template>
                      <span>{{ !showPrice ? $t('_dashChatImageTooltip') : $t('_dashChatImagePriceTooltip') }}</span>
                    </v-tooltip>
                  </div>
                  <div>
                    <span style="color: #a6d95e; font-size: 20px; font-weight: 600"
                      >{{ !showPrice ? item.totalGeneration : formatNumberWithComma((Number.parseFloat(item.totalPrice) * 35).toFixed(2)) }} {{ !showPrice ? '' : $t('baht') }}</span
                    >
                  </div>
                  <div>
                    <span style="color: #a6d95e">{{ $t('LastDays') }} {{ daysDifference }} {{ $t('Days') }}</span>
                  </div>
                </div>
              </v-card>
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <v-overlay :model-value="dialog" class="align-center justify-center">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">{{ $t('loading') }}</h3>
          <p class="loading-subtitle">{{ $t('pleaseWait') }}</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import { Chart } from 'highcharts-vue';
import dateUtils from '../plugins/date-utils';
import Cookies from 'js-cookie';
import moment from 'moment';
export default {
  name: 'Dashboard',
  inject: ['flagNav', 'FontColorTitle', 'SubNavbarBackGround'],
  computed: {
    currentLanguage() {
      return this.$i18n.locale;
    },
    monthList() {
      return [
        { text: this.$t('monthJanuary'), value: 1 },
        { text: this.$t('monthFebruary'), value: 2 },
        { text: this.$t('monthMarch'), value: 3 },
        { text: this.$t('monthApril'), value: 4 },
        { text: this.$t('monthMay'), value: 5 },
        { text: this.$t('monthJune'), value: 6 },
        { text: this.$t('monthJuly'), value: 7 },
        { text: this.$t('monthAugust'), value: 8 },
        { text: this.$t('monthSeptember'), value: 9 },
        { text: this.$t('monthOctober'), value: 10 },
        { text: this.$t('monthNovember'), value: 11 },
        { text: this.$t('monthDecember'), value: 12 },
      ];
    },
  },
  watch: {
    currentLanguage(newLanguage) {
      // อัปเดตข้อความหรือสถานะ component เมื่อภาษาเปลี่ยน
      this.loadTranslations(newLanguage); // เรียกฟังก์ชันเพื่อโหลดข้อมูลหรือข้อความใหม่
    },
    selectedMonth(newMonth) {
      this.applyMonthlyRange(newMonth);
    },
  },
  components: {
    highcharts: Chart,
  },
  data: () => ({
    username: null,
    selectedMonth: null,
    mask: '##########',
    show1: false,
    dialog: false,
    loading: false,
    userList: [],
    panel: [0],
    panel2: [0],
    daysDifference: 0,
    // userId: Cookies.get("userId"),
    today: null,
    totalusage: 0,
    totalusageunit: 'month',
    totalusagelastday: 0,
    totalusagelastdayupdatedin: '-',
    totalusagelastdayupdatedinDate: null,
    totalusagetoken: 0,
    totalusagetokenunit: 'month',
    totalusagetokenschat: 0,
    totalusageprompttokenschat: 0,
    totalusagecompletiontokenschat: 0,
    totalusagetokensembedding: 0,
    totalusageuser: 0,
    totalusageusermax: 0,
    totalusageuserunit: 'month',
    totalusagegptflow: 0,
    totalusagepraphcategories: [],
    totalusagepraphdata: [],
    totalImgModelGen: [],
    language: 'th',

    startDateFlag: false,
    endDateFlag: false,
    startDate: null,
    endDate: null,
    loadingCard: false,
    provider: null,

    rules: {
      required: (value) => !!value || 'Required',
    },
    isChartOptions: false,
    chartOptions: {
      chart: {
        type: 'area',
        backgroundColor: 'transparent',
        spacing: [16, 8, 8, 8],
      },
      title: { text: '' },
      subtitle: { text: '' },
      credits: { enabled: false },
      xAxis: {
        categories: ['01-09', '08-09', '12-09', '16-09'],
        tickLength: 0,
        tickInterval: 1,
        lineColor: '#F0F0F0',
        labels: {
          step: 1,
          style: { color: '#A3A3A3', fontSize: '10px' },
        },
      },
      yAxis: {
        min: 0,
        title: '',
        tickInterval: 10,
        gridLineColor: '#F5F5F5',
        labels: {
          style: { color: '#A3A3A3', fontSize: '10px' },
        },
      },
      tooltip: {
        enabled: false,
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b> {point.y:,.0f} คน</b></td></tr>',
        footerFormat: '</table>',
        shared: false,
        useHTML: false,
      },
      plotOptions: {
        area: {
          marker: {
            enabled: false,
            radius: 3,
          },
          lineWidth: 2,
          states: {
            hover: {
              lineWidth: 2,
            },
          },
        },
      },
      series: [
        {
          type: 'area',
          name: 'จำนวนคน',
          data: [10, 15, 8, 20],
          color: '#F18A7E',
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, 'rgba(241,138,126,0.9)'],
              [1, 'rgba(241,138,126,0)'],
            ],
          },
          marker: { enabled: false },
          lineWidth: 2,
        },
      ],
    },
    chartPie: {
      chart: {
        type: 'pie',
        backgroundColor: 'transparent',
      },
      title: { text: '' },
      subtitle: {
        text: '<span class="donut-total">0<br><span class="donut-total__label">models</span></span>',
        align: 'center',
        verticalAlign: 'middle',
        useHTML: true,
        y: 4,
      },
      tooltip: {
        headerFormat: '<span style="font-size:11px">{point.key}</span><br/>',
        pointFormat: '<span style="color:{point.color}">●</span> <b>{point.percentage:.1f}%</b>',
        valueSuffix: '%',
      },
      credits: { enabled: false },
      legend: {
        align: 'center',
        layout: 'horizontal',
        verticalAlign: 'bottom',
        symbolRadius: 999,
        symbolHeight: 10,
        symbolWidth: 10,
        itemMarginTop: 8,
        itemMarginBottom: 4,
        itemDistance: 20,
        itemStyle: {
          fontWeight: '500',
          fontSize: '13px',
          color: '#171717',
        },
      },
      plotOptions: {
        pie: {
          innerSize: '65%',
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          borderWidth: 0,
        },
      },
      series: [
        {
          name: 'Models',
          colorByPoint: false,
          innerSize: '65%',
          data: [
            { name: 'Chatgpt-4o plus', y: 24, color: '#FFC7C2' },
            { name: 'Chatgpt-4o Pro', y: 22, color: '#FFAD9E' },
            { name: 'Anthropic', y: 18, color: '#FF8C7A' },
            { name: 'Gemini II', y: 16, color: '#A33828' },
            { name: 'Azure', y: 20, color: '#D86B55' },
          ],
        },
      ],
    },
    listDDProvider: [],
    modelUsageTotalText: '0',
    showCardgemini: false,
    showPrice: false,
    CompletionResult: 0,
    PromptPriceResult: 0,
    TotalEmbeddingPrice: 0,
    TotalUsageChatPrice: 0,
    TotalUsedprice: 0,
    PromptPriceGPT3: 0,
    PromptPriceGPT316k: 0,
    PromptPriceGPT4: 0,
    PromptPriceOther: 0,
    CompletionPriceGPT3: 0,
    CompletionPriceGPT316k: 0,
    CompletionPriceGPT4: 0,
    CompletionPriceOther: 0,
    TotalGpt35Prompt: 0,
    TotalGpt316kPrompt: 0,
    TotalGpt4Prompt: 0,
    TotalGpt35Completion: 0,
    TotalGpt316kCompletion: 0,
    TotalGpt4Completion: 0,
    listDetailTokenUsed: null,
    totalImgGenerated: 0,
    totalImgPrice: 0,
    totalAllImgGenerated: 0,
    totalAllImgPrice: 0,
    listImgModelGen: [],
  }),
  methods: {
    applyMonthlyRange(monthValue) {
      if (monthValue === null || monthValue === undefined || monthValue === '') {
        return;
      }

      const monthNumber = Number.parseInt(monthValue, 10);
      if (!Number.isFinite(monthNumber) || monthNumber < 1 || monthNumber > 12) {
        return;
      }

      const year = new Date().getFullYear();
      const start = new Date(year, monthNumber - 1, 1);
      const end = new Date(year, monthNumber, 0);

      this.startDate = this.formatDate(start);
      this.endDate = this.formatDate(end);
      this.startDateFlag = false;
      this.endDateFlag = false;
    },
    loadTranslations(newLanguage) {
      this.language = newLanguage;
      if (this.language == 'th' && this.totalusagelastdayupdatedinDate) this.totalusagelastdayupdatedin = this.convertDateToStringTh(this.totalusagelastdayupdatedinDate);
      else if (this.totalusagelastdayupdatedinDate) this.totalusagelastdayupdatedin = this.convertDateToStringEn(this.totalusagelastdayupdatedinDate);
      this.chartOptions.chart = {
        type: 'area',
        backgroundColor: 'transparent',
        spacing: [16, 8, 8, 8],
      };
      // Titles are handled by the surrounding card UI
      this.chartOptions.title = { text: '' };
      this.chartOptions.subtitle = { text: '' };
      this.chartOptions.yAxis = {
        min: 0,
        title: '',
        tickInterval: 10,
        gridLineColor: '#F5F5F5',
        labels: {
          style: { color: '#A3A3A3', fontSize: '10px' },
        },
      };
      this.chartOptions.plotOptions = {
        area: {
          marker: {
            enabled: false,
            radius: 3,
          },
          lineWidth: 2,
          states: {
            hover: {
              lineWidth: 2,
            },
          },
        },
      };
      this.chartOptions.series = [
        {
          type: 'area',
          name: this.$t('NumberPeople'),
          data: this.totalusagegraphdata,
          color: '#F18A7E',
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, 'rgba(241,138,126,0.9)'],
              [1, 'rgba(241,138,126,0)'],
            ],
          },
          marker: { enabled: false },
          lineWidth: 2,
        },
      ];
      // Re-apply chart labels that are otherwise frozen on locale change (R8)
      this.chartOptions.tooltip = {
        ...this.chartOptions.tooltip,
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b> {point.y:,.0f} ' + this.$t('personUnit') + '</b></td></tr>',
      };
      // Re-apply the donut center label ("models") so it follows the selected locale
      this.updateModelUsageSubtitle(this.modelUsageTotalText);
    },
    ConvertFormat(value) {
      const [intPart, decPart] = value.toString().split('.');
      const grouped = intPart
        .split('')
        .reverse()
        .join('')
        .replace(/(\d{3})(?=\d)/g, '$1,')
        .split('')
        .reverse()
        .join('');
      return decPart !== undefined ? `${grouped}.${decPart}` : grouped;
    },
    formatNumberWithComma(value) {
      const [integerPart, decimalPart] = value.toString().split('.');
      const formattedIntegerPart = integerPart
        .split('')
        .reverse()
        .join('')
        .replace(/(\d{3})(?=\d)/g, '$1,')
        .split('')
        .reverse()
        .join('');
      const formattedDecimalPart = decimalPart ? `.${decimalPart}` : '';
      return formattedIntegerPart + formattedDecimalPart;
    },
    formatDayMonth(dateInput) {
      if (!dateInput) return '';
      const parsed = moment(dateInput, [moment.ISO_8601, 'YYYY-MM-DD', 'YYYY/MM/DD', 'DD/MM/YYYY', 'D/M/YYYY', 'DD-MM-YYYY', 'D-M-YYYY', 'MM/DD/YYYY', 'M/D/YYYY', 'MM-DD-YYYY', 'M-D-YYYY'], true);

      const m = parsed.isValid() ? parsed : moment(dateInput);
      if (!m.isValid()) {
        return String(dateInput);
      }

      return m.format('MM-DD');
    },
    updateModelUsageSubtitle(totalText = '0') {
      const displayValue = totalText;
      this.modelUsageTotalText = totalText;
      this.chartPie = {
        ...this.chartPie,
        subtitle: {
          ...this.chartPie.subtitle,
          text: `<span class="donut-total" style="color: #171717; font-weight: 600; font-size: 16px;">${displayValue}<br><span class="donut-total__label">${this.$t('models')}</span></span>`,
        },
      };
    },
    calculateDaysBetween(start, end) {
      const startDate = new Date(start);
      const endDate = new Date(end);

      if (Number.isNaN(Number(startDate)) || Number.isNaN(Number(endDate))) {
        return 'Invalid date';
      }

      const timeDifference = endDate - startDate;

      this.daysDifference = timeDifference / (1000 * 3600 * 24) + 1;
    },
    Search() {
      this.loading = true;
      this.loadingCard = true;
      this.Get();
    },
    async GetProviderData() {
      this.dialog = true;
      await this.$call.GetDDLProviderData(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDProvider = dataResponse.data;
            this.listDDProvider.push({ id: 0, providerName: 'All' });
            this.listDDProvider.sort(function (a, b) {
              if (a.id < b.id) {
                return -1;
              }
              if (a.id > b.id) {
                return 1;
              }
              return 0;
            });
          } else {
            this.listDDProvider = [];
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    Get() {
      if (this.startDate != null && this.endDate != null) {
        this.calculateDaysBetween(this.startDate, this.endDate);
        let temp = {
          StartDate: this.startDate,
          EndDate: this.endDate,
          ProviderName: this.provider,
        };
        this.loadingCard = true;
        this.$call.GetDashboardOverview(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              const data = dataResponse.data;
              this.totalusage = this.ConvertFormat(data.totalUsage);
              this.totalusageunit = data.totalUsageUnit;
              this.totalusagelastday = this.ConvertFormat(data.totalUsageLastDay);
              this.totalusagelastdayupdatedinDate = data.totalUsageLastDayUpdatedIn;
              this.totalImgModelGen = data.totalImageModelGeneration;
              this.totalAllImgGenerated = data.totalGenImg;
              this.totalAllImgPrice = data.totalGenImgPrice;
              // if(this.provider == "Azure"){
              //   this.totalusageprompttokenschat = this.ConvertFormat(data.modelTokens.totalPrompt_tokens).Sum();
              //   this.totalusagecompletiontokenschat = this.ConvertFormat(data.modelTokens.totalCompletion_tokens).Sum();
              //   this.totalusagetokenschat =  this.ConvertFormat(this.totalusageprompttokenschat + this.totalusagecompletiontokenschat);
              //   this.totalusagetoken = this.ConvertFormat(data.totalUsageTokensEmbedding  this.totalusagetokenschat);
              //   console.log()
              // }
              // else if (this.provider == "Google"){
              //   this.totalusageprompttokenschat = this.ConvertFormat(data.modelTokens.totalPrompt_tokens).Sum();
              //   this.totalusagecompletiontokenschat = this.ConvertFormat(data.modelTokens.totalCompletion_tokens).Sum();
              //   this.totalusagetokenschat =  this.ConvertFormat(this.totalusageprompttokenschat + this.totalusagecompletiontokenschat);
              //   this.totalusagetoken = this.ConvertFormat(data.totalUsageTokensEmbedding + this.totalusagetokenschat);
              //   console.log()
              // }
              // else if (this.provider == "Anthropic"){
              //   this.totalusageprompttokenschat = this.ConvertFormat(data.modelTokens.totalPrompt_tokens).Sum();
              //   this.totalusagecompletiontokenschat = this.ConvertFormat(data.modelTokens.totalCompletion_tokens).Sum();
              //   this.totalusagetokenschat =  this.ConvertFormat(this.totalusageprompttokenschat + this.totalusagecompletiontokenschat);
              //   this.totalusagetoken = this.ConvertFormat(data.totalUsageTokensEmbedding + this.totalusagetokenschat);
              //   console.log()
              // }
              if (this.provider == 'All') {
                this.totalImgGenerated = this.ConvertFormat(this.totalImgModelGen.reduce((sum, item) => sum + (item.totalGeneration || 0), 0));
                this.listImgModelGen = this.totalImgModelGen;
                this.totalImgPrice = 0;
                this.listImgModelGen.forEach((e) => {
                  this.totalImgPrice += Number.parseFloat(e.totalPrice).toFixed(2);
                });

                this.totalusagetoken = this.ConvertFormat(data.totalUsageToken);
                this.totalusagetokenschat = this.ConvertFormat(data.totalUsageTokensChat);
                this.totalusagetokensembedding = this.ConvertFormat(data.totalUsageTokensEmbedding);
                this.totalusageprompttokenschat = this.ConvertFormat(data.totalUsagePromptTokensChat);
                this.totalusagecompletiontokenschat = this.ConvertFormat(data.totalUsageCompletionTokensChat);
              } else {
                this.totalImgGenerated = this.ConvertFormat(this.totalImgModelGen.filter((e) => e.provider == this.provider).reduce((sum, item) => sum + (item.totalGeneration || 0), 0));
                this.listImgModelGen = this.totalImgModelGen.filter((e) => e.provider == this.provider);

                this.totalImgPrice = 0;
                this.listImgModelGen.forEach((e) => {
                  this.totalImgPrice += Number.parseFloat(e.totalPrice).toFixed(2);
                });

                let temp = data.modelTokens.filter((e) => e.provider == this.provider);
                let temptotalusageprompttokenschat = temp.reduce((sum, o) => sum + Number.parseFloat(o.totalPrompt_tokens), 0);
                let temptotalusagecompletiontokenschat = temp.reduce((sum, o) => sum + Number.parseFloat(o.totalCompletion_tokens), 0);
                let temptotalusagetokenschat = temptotalusageprompttokenschat + temptotalusagecompletiontokenschat;
                this.totalusageprompttokenschat = this.ConvertFormat(temptotalusageprompttokenschat);
                this.totalusagecompletiontokenschat = this.ConvertFormat(temptotalusagecompletiontokenschat);
                this.totalusagetokensembedding = this.ConvertFormat(data.totalUsageTokensEmbedding);
                this.totalusagetokenschat = this.ConvertFormat(temptotalusagetokenschat);
                this.totalusagetoken = this.ConvertFormat(data.totalUsageTokensEmbedding + temptotalusagetokenschat);
              }

              this.totalusagetokenunit = data.totalUsageTokenUnit;
              this.totalusageuser = this.ConvertFormat(data.totalUsageUser);
              this.totalusageusermax = this.ConvertFormat(data.totalUsageUserMax);
              this.totalusageuserunit = data.totalUsageUserUnit;
              this.totalusagegptflow = this.ConvertFormat(data.totalUsageGPTFlow);
              this.updateModelUsageSubtitle(this.totalusagegptflow);
              this.totalusagegraphcategories = data.totalUsageGraphCategories;
              this.totalusagegraphdata = data.totalUsageGraphData;
              this.listDetailTokenUsed = data.modelTokens.map((items, index) => ({
                key: index + 1,
                provider: items.provider,
                modelName: items.modelName,
                completionPrice: items.completionPrice,
                promptPrice: items.promptPrice,
                totalPrompt_Price: Number.parseFloat((Number.parseInt(items.totalPrompt_tokens) / 1000) * items.promptPrice * 35).toFixed(2),
                totalCompletion_Price: Number.parseFloat((Number.parseInt(items.totalCompletion_tokens) / 1000) * items.completionPrice * 35).toFixed(2),
                totalCompletion_tokens: this.ConvertFormat(items.totalCompletion_tokens),
                totalPrompt_tokens: this.ConvertFormat(items.totalPrompt_tokens),
              }));

              if (this.provider != 'All') {
                this.listDetailTokenUsed = this.listDetailTokenUsed.filter((e) => e.provider == this.provider);
              }

              const promtPrice = Number.parseFloat(this.listDetailTokenUsed.reduce((sum, o) => sum + Number.parseFloat(o.totalPrompt_Price), 0)).toFixed(2);
              const completionPrice = Number.parseFloat(this.listDetailTokenUsed.reduce((sum, o) => sum + Number.parseFloat(o.totalCompletion_Price), 0)).toFixed(2);
              const totalUsageChatPrice = (Number.parseFloat(completionPrice) + Number.parseFloat(promtPrice)).toFixed(2);
              const totalEmbeddingPrice = Number.parseFloat((data.totalUsageTokensEmbedding / 1000) * 0.0001 * 35).toFixed(2);
              const totalUsedprice = (Number.parseFloat(totalUsageChatPrice) + Number.parseFloat(totalEmbeddingPrice)).toFixed(2);

              this.PromptPriceResult = promtPrice;
              this.CompletionResult = completionPrice;
              this.TotalEmbeddingPrice = totalEmbeddingPrice;
              this.TotalUsageChatPrice = totalUsageChatPrice;
              this.TotalUsedprice = totalUsedprice;

              const formattedCategories = (this.totalusagegraphcategories || []).map((c) => this.formatDayMonth(c));

              this.chartOptions.xAxis = {
                categories: formattedCategories,
                tickLength: 0,
                tickInterval: 1,
                lineColor: '#F0F0F0',
                labels: {
                  step: 1,
                  style: { color: '#A3A3A3', fontSize: '10px' },
                },
              };

              // จัดการเรื่องภาษาของ chart
              if (this.language == 'th') this.totalusagelastdayupdatedin = this.convertDateToStringTh(this.totalusagelastdayupdatedinDate);
              else this.totalusagelastdayupdatedin = this.convertDateToStringEn(this.totalusagelastdayupdatedinDate);
              this.chartOptions.chart = {
                type: 'area',
                backgroundColor: 'transparent',
                spacing: [16, 8, 8, 8],
              };
              this.chartOptions.title = { text: '' };
              this.chartOptions.subtitle = { text: '' };
              this.chartOptions.yAxis = {
                min: 0,
                title: '',
                tickInterval: 10,
                gridLineColor: '#F5F5F5',
                labels: {
                  style: { color: '#A3A3A3', fontSize: '10px' },
                },
              };
              this.chartOptions.plotOptions = {
                area: {
                  marker: {
                    enabled: false,
                    radius: 3,
                  },
                  lineWidth: 2,
                  states: {
                    hover: {
                      lineWidth: 2,
                    },
                  },
                },
              };
              this.chartOptions.series = [
                {
                  type: 'area',
                  name: '',
                  // name: this.$t("NumberPeople"),
                  data: this.totalusagegraphdata,
                  color: '#F18A7E',
                  fillColor: {
                    linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                    stops: [
                      [0, 'rgba(241,138,126,0.9)'],
                      [1, 'rgba(241,138,126,0)'],
                    ],
                  },
                  marker: { enabled: false },
                  lineWidth: 2,
                },
              ];

              this.isChartOptions = true;
            }
            this.loadingCard = false;
          },
          (errorResource) => {
            this.dialog = false;
            this.Adddialog = false;
            console.error(errorResource);
            this.loadingCard = false;
          }
        );
      }
      // else
      // {
      //   self.$swal.fire({
      //     icon: 'warning',
      //     title: self.$t('warning'),
      //     text: 'Please fill the required fields!!!',
      //     showConfirmButton: false,
      //     timer: 1800,
      //   });
      //   self.loading = false;
      //   return;
      // }
    },
    convertDateToStringEn(date, seperator = '/') {
      return dateUtils.getStringWithMonthEnNameFromDate(moment(date).toDate(), seperator);
    },
    convertDateToStringTh(date, seperator = '/') {
      return dateUtils.getStringWithMonthNameFromDate(moment(date).toDate(), seperator);
    },
    convertDateToString2(date, seperator = '-') {
      return dateUtils.getStringFromDatePickFormatDatePick2(moment(date).toDate(), seperator);
    },
  },
  mounted() {
    this.loadingCard = true;
    this.GetDate();
    this.username = Cookies.get('fullName') || Cookies.get('username') || 'User';
    const datesubtract = new Date();
    datesubtract.setDate(datesubtract.getDate() - 2);
    const date = new Date();
    this.startDate = this.convertDateToString2(datesubtract);
    this.endDate = this.convertDateToString2(date);
    this.GetProviderData();
    this.Get();
    this.provider = 'All';
    this.language = this.$i18n.locale;
  },
};
</script>
<style scoped>
.modern-input :deep(.v-field) {
  border: 1px solid #c9c9c9;
  border-radius: 10px;
  padding: 4px !important;
}
.modern-input :deep(.v-field .v-icon) {
  margin-top: -4px !important;
}
.modern-input :deep(.v-field:hover) {
  background-color: #f1f5f9 !important;
}
.modern-input :deep(.v-field__input) {
  padding: 4px 10px !important;
}

.modern-input :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
  margin-top: 4px;
}
.modern-input :deep(.v-list .v-list-item--active .v-list-item-title) {
  color: #872612 !important;
  font-weight: 700;
}
.modern-input :deep(.v-list .v-list-item:hover .v-list-item-title) {
  color: #872612 !important;
}
.date-style {
  border: 1px solid #c9c9c9;
  border-radius: 10px;
  height: 44px;
  padding: 2px !important;
}
.monthly-input :deep(.v-field) {
  border: 1px solid #c9c9c9;
  border-radius: 16px;
  width: 176px;
}
.monthly-input :deep(.v-field .v-icon) {
  margin-top: -3px !important;
}
.monthly-input :deep(.v-field:hover) {
  background: #ffffff !important;
}
.monthly-input :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
  margin-top: 4px;
}
.monthly-input :deep(.v-list .v-list-item--active .v-list-item-title) {
  color: #872612 !important;
  font-weight: 800;
}
.monthly-input :deep(.v-list .v-list-item:hover .v-list-item-title) {
  color: #872612 !important;
}
.monthly-input :deep(input::placeholder) {
  top: -3px;
}
.monthly-input :deep(.v-field__input) {
  top: -3px;
}
.monthly-design {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.search-btn {
  background: linear-gradient(100deg, #c32e0e 0%, #f67760 100%) !important;
  height: 36px;
  width: 36px;
  border-radius: 18px;
  margin-left: -8px;
}

@media (max-width: 959px) {
  .dashboard-date-divider-col {
    display: none;
  }
  .search-btn {
    margin-left: 0;
  }
}

@media (min-width: 960px) and (max-width: 1263px) {
  .dashboard-date-divider-col {
    display: none;
  }
  .search-btn {
    margin-right: 12px;
  }
}
.date-divider-style {
  display: flex;
  justify-content: flex-start;
}
.date-divider {
  color: #c9c9c9;
  font-weight: 700;
  margin-top: 38px;
}
.card-design {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
}
.lastday-deseign {
  background: #ffffff;
  border-radius: 12px;
  padding: 4px 8px !important;
  width: 140px;
  display: flex;
  align-items: center;
  justify-content: center !important;
}
.card-1 {
  background-image: url('@/assets/Total users.svg');
  background-size: cover;
  background-position: center;
  border-radius: 14px;
  box-shadow: none;
  width: 100%;
  height: 180px;
  padding: 16px !important;
}
.total-model-card {
  background-image: url('@/assets/Total Models.svg');
  background-size: cover;
  background-position: center;
  border-radius: 14px;
  box-shadow: none;
  width: 100%;
  height: 180px;
  padding: 16px !important;
}
.show-price-group {
  border: 1px solid #c9c9c9;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 16px;
  gap: 8px;
  margin: 16px;
}
.action-divider {
  width: 2px;
  height: 28px;
  background: rgba(0, 0, 0, 0.12);
  border-radius: 1px;
  transition: background-color 0.2s ease;
}
/* v-switch */
.memory-switch :deep(.v-switch__track) {
  background: #a6a6a6 !important;
  border: 1px solid #ffffff !important;
  opacity: 1 !important;
  height: 20px !important;
  width: 32px !important;
  border-radius: 22px !important;
}
.memory-switch :deep(.v-switch__thumb) {
  box-shadow: none !important;
  height: 16px !important;
  width: 16px !important;
  margin-left: 4px !important;
  background-color: #ffffff !important;
}
/* Active (on) state */
.memory-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: #ffffff !important;
  border: 1px solid #c32e0e !important;
}
.memory-switch :deep(.v-selection-control--dirty .v-switch__thumb) {
  background-color: #c32e0e !important;
  margin-right: 8px !important;
}
.memory-switch :deep(.v-switch__loader) {
  display: none !important;
}

.card-2 {
  border-radius: 13px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 400px;
  flex-shrink: 0;
}

.card-3 {
  background-image: url('@/assets/Total tokens used png_0.png');
  background-size: cover;
  background-position: center;
  border-radius: 13px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 120px;
}
.card-4 {
  background-image: url('@/assets/Total tokens used in chat_0.png');
  background-size: cover;
  background-position: center;
  border-radius: 13px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 120px;
}
.card-5 {
  background-image: url('@/assets/Total embedding_0.png');
  background-size: cover;
  background-position: center;
  border-radius: 13px;
  width: 100%;
  height: 120px;
}
.card-6 {
  background-image: url('@/assets/Totle image_0.png');
  background-size: cover;
  background-position: center;
  border-radius: 13px;
  width: 100%;
  height: 120px;
}
.token-model-card-1 {
  background-image: url('@/assets/Total prompt tokens.png');
  background-size: cover;
  background-position: center;
  border-radius: 13px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
  width: 100%;
  height: 120px;
  padding: 0px 8px;
}
.token-model-card-2 {
  background-image: url('@/assets/Total completion.png');
  background-size: cover;
  background-position: center;
  border-radius: 13px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
  width: 100%;
  height: 120px;
  padding: 0px 8px;
}
.token-model-card-3 {
  background-image: url('@/assets/Total gpt.png');
  background-size: cover;
  background-position: center;
  border-radius: 13px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
  width: 100%;
  height: 120px;
  padding: 0px 8px;
}
.token-model-card-4 {
  background-image: url('@/assets/Total completion gpt.png');
  background-size: cover;
  background-position: center;
  border-radius: 13px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
  width: 100%;
  height: 120px;
  padding: 0px 8px;
}
.image-gerneration-card-1 {
  background-image: url('@/assets/Total generated image.png');
  background-size: cover;
  background-position: auto;
  border-radius: 13px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
  width: 100%;
  height: 120px;
  padding: 0px 8px;
}
.image-gerneration-card-2 {
  background-image: url('@/assets/Container image.png');
  background-size: cover;
  background-position: auto;
  border-radius: 13px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
  width: 100%;
  height: 120px;
  padding: 0px 8px;
}
.title-icon {
  display: flex !important;
  justify-content: start !important;
  gap: 8px !important;
}
.doughnut-chart-card {
  border-radius: 10px;
  border: 1px solid #c9c9c9 !important;
  padding: 8px !important;
  box-shadow: none;
}
.line-chart-card {
  border-radius: 10px;
  border: 1px solid #c9c9c9 !important;
  padding: 8px !important;
  box-shadow: none;
  width: 100%;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
.card2 {
  border: 1px solid #dcdcdc !important;
  border-radius: 10px !important;
  box-shadow: none;
}

.circular--portrait {
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
  border-radius: 50%;
}

.circular--portrait img {
  width: 100%;
  height: auto;
}

.gradient-red {
  background: -webkit-linear-gradient(red, yellow);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gradient-purple {
  background: -webkit-linear-gradient(#9747ff, #5179ef);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
